"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkMessageFormatter = void 0;
var sdk_message_formatter_1 = require("./sdk-message-formatter");
Object.defineProperty(exports, "sdkMessageFormatter", { enumerable: true, get: function () { return sdk_message_formatter_1.sdkMessageFormatter; } });
//# sourceMappingURL=index.js.map